import { render } from "./UserMenu.vue?vue&type=template&id=1e430f8e&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=1e430f8e&scoped=true&lang=css"
import "./UserMenu.vue?vue&type=style&index=1&id=1e430f8e&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e430f8e"]])

export default __exports__